import { useSelector } from "react-redux";
import { getPhoto, getName, getSessionId, getTableNumber, getCreateResult, clearAction } from "../redux/slices";
import React, { useEffect, useState } from "react";

import { useAppDispatch } from "../redux/hooks";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loading } from "./Loading";
import { trackEvent } from "../utils/analytics";

import "./playerEntryComplete.scss";

export const PlayerEntryComplete: React.FC = () => {
  const nav = useNavigate();
  const name = useSelector(getName);
  const photo = useSelector(getPhoto);
  const dispatch = useAppDispatch();
  const createResult = useSelector(getCreateResult);

  // BEGIN copied link checking

  const [loading, setLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();

  // if the redux store is missing a session ID (or the session ID does not match the URL parameter),
  // then redirect to the start page. Suspect that this is a shared link and this "new" user needs to start at the beginning of the journey
  let sessionIdParam = searchParams.get("s");
  let tableNumberParam = searchParams.get("t");
  let venueCode = searchParams.get("v");
  const sessionIdRedux = useSelector(getSessionId);
  const tableNumberRedux = useSelector(getTableNumber);

  useEffect(() => {
    if (sessionIdRedux === null || tableNumberRedux === null) {
      nav(`/?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
    }

    if (sessionIdParam !== sessionIdRedux || tableNumberParam !== tableNumberRedux) {
      nav(`/?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
    } else {
      setLoading(false);
    }
  }, [sessionIdParam, tableNumberParam, venueCode, sessionIdRedux, tableNumberRedux, nav]);

  // END of "copied link" checking

  // start the process again
  const addfriend = () => {
    trackEvent({
      gaEvent: "click_add_friend",
      clarityEvent: "click_add_friend",
      params: { venue_code: venueCode },
    });
    sessionStorage.removeItem("hasTakenPhoto");
    sessionStorage.removeItem("hasVisitedPhotoPage");
    dispatch(clearAction());
    nav(`/nickname?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
  };

  if (loading) return <Loading />;

  const isTableSuccess = createResult?.createSuccess && createResult?.ocheNumber > 0;
  const isLobby = createResult?.createSuccess && createResult?.ocheNumber === 0;

  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/fc-logo.svg"} width="125px" alt="Flight Club" />
      </div>
      <div className="contentCard-outer">
        <div className="contentCard contentCard--complete">
          <div className="completeInner">
            <div className="completeYoureIn">You're in!</div>
            {isTableSuccess ? (
              <div className="completeHeading">ENJOY THE GAME {name}</div>
            ) : isLobby ? (
              <div className="completeHeading">
                NOW CHECK IN
                <br />
                ON A TABLE
              </div>
            ) : (
              <div className="completeHeading">
                ENJOY THE GAME
                <br />
                {name}
              </div>
            )}
            <div className="circlePhotoContainer">
              <img className="circleWebcam" src={photo} alt={name} />
            </div>
            <p className="completeFriendText">
              Are you with a friend
              <br />
              who hasn't joined yet?
            </p>
          </div>
        </div>
        <span className="corner-bottom-left" />
        <span className="corner-bottom-right" />
      </div>
      <footer className="btn-container">
        <button className="button" onClick={addfriend}>
          ADD A PLAYER
        </button>
      </footer>
    </div>
  );
};
